import { dispatcher } from "@quest/base-core";

import { eventDispatchers } from "../Constants/EventDispatchers";
import { TopLogoController } from "@quest/murka-games-behavior-leopard/dist/Game/TopLogo/TopLogoController";

export class TopLogoControllerGame extends TopLogoController {
  // Overrided to subscribe game end events
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.TOP_LOGO_HIDE_ON_BIG_WIN, this.topLogoHideOnBigWin, this);
    dispatcher.on(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN, this.topLogoShowOnBigWin, this);
  }

  // Overrided to unsubscribe game end events
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.TOP_LOGO_HIDE_ON_BIG_WIN, this.topLogoHideOnBigWin, this);
    dispatcher.off(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN, this.topLogoShowOnBigWin, this);
  }

  // Add to hide portrait logo on big win
  private topLogoHideOnBigWin(): void {
    this.view.getContainerByID("topLogoContainer").visible = false;
  }

  // Add to show portrait logo on big win
  private topLogoShowOnBigWin(): void {
    this.view.getContainerByID("topLogoContainer").visible = true;
  }

  
}
